export default __webpack_public_path__ + "static/media/pvdx_figma.fe89ca98.png";